import { render, staticRenderFns } from "./curve-line.vue?vue&type=template&id=2c39b024&scoped=true&"
import script from "./curve-line.vue?vue&type=script&lang=ts&"
export * from "./curve-line.vue?vue&type=script&lang=ts&"
import style0 from "./curve-line.vue?vue&type=style&index=0&id=2c39b024&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c39b024",
  null
  
)

export default component.exports